<!--suppress ALL -->

<template>
	<tr>
		<td class="text-xs-center">
			{{organization.name }}
		</td>
		<td class="text-xs-center">
			{{organization.style }}
		</td>
		<td class="text-xs-center">
			{{organization.domain }}
		</td>
		<!--		<td class="text-xs-center">-->
		<!--			{{organization.view }}-->
		<!--		</td>-->
		<td class="text-xs-center">
			{{organization.show_updates }}
		</td>
		<td class="text-xs-center">
			{{organization.out_register }}
		</td>
		<td class="text-xs-center">
			{{organization.price }}
		</td>
		<td>
			<edit-btn @click="onEdit"/>
			<remove-btn/>
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/Organization.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "organization-row",
		props: {
			organization:{required:true}
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "organization")],
		data() {
			return {};
		},
		computed: {},
		methods: {
			doRemove() {
				this.$store.dispatch(types.REMOVE, this.organization).then(() => {
				});
			},
			onEdit() {
				this.$emit("edit", this.organization);
			}
		}
	};
</script>

<style>


</style>
